
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","fill":"white"}}),_c('path',{attrs:{"d":"M33.0933 41C32.9173 41 32.7733 40.944 32.6613 40.832C32.5653 40.72 32.5173 40.584 32.5173 40.424V27.992L28.8693 30.8C28.7253 30.896 28.5813 30.936 28.4373 30.92C28.2933 30.888 28.1653 30.8 28.0533 30.656L27.0453 29.36C26.9493 29.216 26.9093 29.064 26.9253 28.904C26.9573 28.744 27.0453 28.616 27.1893 28.52L32.5653 24.368C32.6613 24.288 32.7573 24.24 32.8533 24.224C32.9493 24.208 33.0533 24.2 33.1653 24.2H35.2773C35.4373 24.2 35.5733 24.256 35.6853 24.368C35.7973 24.48 35.8533 24.616 35.8533 24.776V40.424C35.8533 40.584 35.7973 40.72 35.6853 40.832C35.5733 40.944 35.4373 41 35.2773 41H33.0933Z","fill":"#12022F"}})])
          )
        }
      }
    